"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _dropdownitem_styles = _interopRequireDefault(require("./dropdownitem_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// styles

/* ========== ~~~~~~~~~~ EXPORT : SEARCHABLE DROPDOWN : DROPDOWN ITEM ~~~~~~~~~~ ========== */


var _default = (0, _reactJss.default)(_dropdownitem_styles.default)(function (props) {
  var renderItemText = function renderItemText() {
    var item = props.name;
    var searchText = props.searchTerm;
    var beginningText = item.slice(0, item.toLowerCase().indexOf(searchText.toLowerCase()));
    var highlightedText = item.slice(item.toLowerCase().indexOf(searchText.toLowerCase()), item.toLowerCase().indexOf(searchText.toLowerCase()) + searchText.length);
    var endingText = item.slice(item.toLowerCase().indexOf(searchText.toLowerCase()) + searchText.length, item.length);
    return _react.default.createElement("div", {
      className: 'itemtext'
    }, _react.default.createElement("span", null, beginningText), _react.default.createElement("span", {
      className: "highlight"
    }, highlightedText), _react.default.createElement("span", null, endingText));
  };

  return _react.default.createElement("div", {
    onClick: function onClick() {
      return props.handleSelect(props.item);
    },
    className: "dropDownItem ".concat(props.classes.dropDownItem, " name-").concat(props.name)
  }, renderItemText());
});

exports.default = _default;